<template>
  <div class="panel panel-default">
    <div class="panel-heading" @click="selectPanelType(id)">
      <h4 class="panel-title mt-10">
        <slot name="title"></slot>
      </h4>
    </div>
    <div :id="`collapse${id}`" class="panel-collapse collapse">
      <div class="panel-body">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'BaseAccordionPanelWithRadio',
    props: {
      id: {
        type: String,
        required: true,
        default: '1',
      },
      currentSelectedKey: {
        type: String,
        required: true,
        default: 1,
      },
    },

    methods: {
      selectPanelType(type) {
        $(`#collapse${this.currentSelectedKey}`).collapse('hide');
        this.$emit('updateRadioKey', type);
        $(`#collapse${type}`).collapse('show');
      },
    },
  };
</script>
